'use strict';

angular.module('mailController', ['ngSanitize'])
.controller('MailController', ['appInfo', '$scope', '$rootScope', '$log', '$filter', '$location', '$timeout', '$routeParams', '$sce', 'SellerService', 'MailService',
    function (appInfo, $scope, $rootScope, $log, $filter, $location, $timeout, $routeParams, $sce, SellerService, MailService) {
    
    $rootScope.header.style = "collapse";
    $rootScope.header.show = false;
    $scope.page = 'mail';

    //Check auth credentials
    var currentUser = $rootScope.currentUser
    ,ekey = currentUser.authdata
    ,name = currentUser.name
    ,timer
    ,markAsRead
    ;

    var messageRef = ($routeParams.id)? $routeParams.id : 0;

    $scope.today = moment.unix(appInfo.today).format("dddd, MMMM Do YYYY");
    $scope.messages = [];
    $scope.selectedMessage = {};
    $scope.agencyContacts = [];
    $scope.newMessage = {};
    $scope.showModal = false;
   
    

    $scope.modalOptions = {
        closable: true,
        // duration: 4000,
        extraClasses: ['fullscreen'],
        onApprove: function() {
            $scope.sendMessage();
        },
        onDeny: function() {
            $scope.hideModal();
        }
    };

    $scope.openModal = function(from) {

        if(from == 'reply')
        {
            $scope.newMessage.communication.header = 'Reply To Message';
            $scope.newMessage.communication.subject = 'Re:'+$scope.selectedMessage.subject;
        }
        $scope.showModal = true;
    };

    $scope.hideModal = function() {
        $scope.showModal = false;
    };

    $scope.trustedHtml = function(html) {
        return $sce.trustAsHtml(html);
    }

    $scope.showMessage = function (ref) {
        $location.path('/mail/message/'+ref);
    };

    $scope.filterMail = function (src) {
        //$rootScope.currentListing.messages = $filter('messages')( $rootScope.currentListing.data.messages, src );
       // $rootScope.currentListing.showInbox = (src == 'inbox')? true : false;
    }

    $scope.getMessage = function() {
        $rootScope.loading = true;

        angular.forEach($rootScope.currentListing.data.messages, function(msg) {
            if(msg.ref == messageRef) {
                $scope.selectedMessage = msg;
            }
        });

        $rootScope.loading = false;

console.log('scope.selectedMessage.fromRef.agent == '+$scope.selectedMessage.fromRef.agent) ;


        //Start timeout to mark message as read after 5 seconds for current inbox message
        if(typeof $scope.selectedMessage.fromRef.agent !== 'undefined') {

            markAsRead = $timeout(function(){
                //Find the current message
                angular.forEach($rootScope.currentListing.data.messages, function(msg) {
                    if(msg.ref == messageRef) {

console.log('MailService.markAsRead = '+messageRef);

                        MailService.markAsRead(ekey, msg.ref).then(function(response) {
                            $log.debug(response);

                        });
                        msg.read = appInfo.today;

                        // Subtract from notifications in menu
                        if($rootScope.currentListing.notifications.mail > 0){
                            $rootScope.currentListing.notifications.mail --;
                        }
                        
                    }
                });
             }, 5000);
        }
    };

    $scope.startNewMessage = function() {
        $scope.newMessage.property = parseInt($rootScope.currentListing.propertyRef);
        $scope.newMessage.usercode = ekey;
        $scope.newMessage.communication = {toRef: {agent: [ parseInt($rootScope.currentListing.agentRef) ]}, fromRef: {seller: [ parseInt($rootScope.currentListing.sellerRef) ]},  ccToMe: 0, incLeader: 0 };
        $scope.newMessage.communication.header = 'Compose New Message';
    };

    $scope.sendMessage = function() {
        MailService.sendMail($scope.newMessage).then(function(response) {
            $log.debug(response);
        });
    };
    $scope.back2Messages = function () {
        $location.path('/mail');
    };

    $scope.loadMessages = function (){
        $rootScope.loading = true;

        //Cancel any pending timeouts
        $timeout.cancel(markAsRead); 

        //$scope.filterMail('inbox');
       
        $rootScope.loading = false; 
    };
       
}]);